export interface ShopSettings {
  id: string
  // Shop
  shopName: string
  slogan: string
  description: string
  address: string
  workingHours: string
  logoUrl: string
  faviconUrl: string
  // Liên hệ
  hotline: string
  email: string
  facebookUrl: string
  youtubeUrl: string
  instagramUrl: string
  zaloPhone: string
  // Ngân hàng
  bankBin: string
  bankShortName: string
  bankAccountNo: string
  bankAccountName: string
  qrEnabled: boolean
  codEnabled: boolean
  // Vận chuyển
  freeShippingThreshold: number
  defaultShippingFee: number
  returnPolicyDays: number
  warrantyMonths: number
  updatedAt: string
}

export const DEFAULT_SETTINGS: ShopSettings = {
  id: 'default',
  shopName: 'Xe Điện Việt',
  slogan: 'Di chuyển xanh — Cuộc sống đẹp hơn',
  description: '',
  address: '',
  workingHours: 'Thứ 2 — Chủ nhật: 8:00 — 20:00',
  logoUrl: '',
  faviconUrl: '',
  hotline: '1800 1234',
  email: 'hello@xediendviet.vn',
  facebookUrl: '',
  youtubeUrl: '',
  instagramUrl: '',
  zaloPhone: '',
  bankBin: '970436',
  bankShortName: 'Vietcombank',
  bankAccountNo: '',
  bankAccountName: '',
  qrEnabled: true,
  codEnabled: true,
  freeShippingThreshold: 5_000_000,
  defaultShippingFee: 50_000,
  returnPolicyDays: 7,
  warrantyMonths: 36,
  updatedAt: new Date().toISOString(),
}
